/**
 * sourcesApi.js
 * -------------
 * API client for Lead / Inquiry Source Master (Sources) using createMasterApiClient.
 * Connects directly to FastAPI backend /sources/ endpoints.
 * 100% conforming to module_implementation_standards.md.
 */
import { createMasterApiClient } from '../../common/masterApiFactory';

export const sourcesClient = createMasterApiClient('sources');

export const listSources = (params) => sourcesClient.list(params);
export const getSourceDetail = (id) => sourcesClient.getById(id);
export const createSource = (data) => sourcesClient.create(data);
export const updateSource = (id, data) => sourcesClient.update(id, data);
export const archiveSource = (id) => sourcesClient.archive(id);
export const deleteSource = (id) => sourcesClient.remove(id);
export const getSourceOptions = () => sourcesClient.getDropdownOptions();
